(function() {
	// 列表对象,属性有data(列表数据)、timeStamp(时间戳)
	var listBean = {};
	// 限制超时时间
	var limitTime = 5 * 60 * 1000; // 保留5分钟
	var moduleType = function($iq_http, $iq_server, $q) {
		// 结果列表
		var list = [];
		return {
			// controller调用的函数
			getAll : function() {
				var def = $q.defer();
				// 如果数据存在并且时间未超出有效范围
				if (listBean.data
						&& listBean.timestamp > new Date() - limitTime) {
					list = listBean.data;
					def.resolve(list);
				} else {
					// 数据不存在或者时间失效，都要重新请求数据
					$iq_http.http({
								method : "GET",
								url : $iq_server.server() + "modules/allowed?approve-app=1"
							}).then(function(data) {
								list = data.data.data;
								// 将数据存入对象，并记录当前时间戳
								listBean.data = list;
								listBean.timestamp = new Date();
								def.resolve(list);
							}, function() {
								def.reject(list);
							})
				}
				return def.promise;
			}
		}

	}
	var microblogList = function($iq_http, $iq_server) {
		var list = []; // 列表数据

		var getPageList = function(callback, blogParam) {// 从远程获取列表数据
			var func = {
				success : function(re) {
					list = re.data.data;
					if (callback) {
						callback(list);// 直接返回list 还是返回list.copy
					}
				}
			}
			var params = {
				params : blogParam,
				method : "GET",
				url : $iq_server.server() + "blogall/data/blogs"
			}

			$iq_http.http(params, func);
		}

		var getAttentionList = function(callback, attentionParam) {// 从远程获取列表数据
			var func = {
				success : function(re) {
					list = re.data.data;
					if (callback) {
						callback(list);// 直接返回list 还是返回list.copy
					}
				}
			}
			var params = {
				params : attentionParam,
				method : "GET",
				url : $iq_server.server() + "blogall/data/attentions"
			}

			$iq_http.http(params, func);
		}

		var getTopicsList = function(callback, topicParam) {// 从远程获取列表数据
			var func = {
				success : function(re) {
					list = re.data.data;
					if (callback) {
						callback(list);// 直接返回list 还是返回list.copy
					}
				}
			}
			var params = {
				params : topicParam,
				method : "GET",
				url : $iq_server.server() + "blogall/data/topicses"
			}

			$iq_http.http(params, func);
		}

		var save = function(datas, success) {
			var blogParam = datas;
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				data : blogParam,
				method : "POST",
				url : $iq_server.server() + "microblog/data/blog",
				dataType : "json"
			}
			$iq_http.http(params, func);
		}

		var del = function(param, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				method : "DELETE",
				url : $iq_server.server() + "blogall/data/blogs/" + param.id
			}
			$iq_http.http(params, func);
		}

		var addGood = function(good, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				method : "POST",
				url : $iq_server.server() + "blogall/data/good/" + good.id
			}
			$iq_http.http(params, func);
		}

		var removeGood = function(good, success) {
			var func = {
				success : function(re) {
					if (success) {
						success(re);
					}
				}
			}
			var params = {
				method : "DELETE",
				url : $iq_server.server() + "blogall/data/good/" + good.id
			}
			$iq_http.http(params, func);
		}

		return {
			all : function() {
				return list;
			},
			getPageList : getPageList,
			getAttentionList : getAttentionList,
			getTopicsList : getTopicsList,
			save : save,
			del : del,
			addGood : addGood,
			removeGood : removeGood
			,
		}
	}

	var topicList = function($iq_http, $iq_server) {
		var list = []; // 列表数据

		var getAllList = function(callback) {// 从远程获取列表数据
			var func = {
				success : function(re) {
					list = re.data.data;
					if (callback) {
						callback(list);// 直接返回list 还是返回list.copy
					}
				}
			}
			var params = {
				method : "GET",
				url : $iq_server.server() + "topic/datas"
			}

			$iq_http.http(params, func);
		}

		var getTopicRelations = function(callback, paramdata) {// 从远程获取列表数据
			var func = {
				success : function(re) {
					list = re.data.data;
					if (callback) {
						callback(list);// 直接返回list 还是返回list.copy
					}
				}
			}
			var params = {
				method : "GET",
				url : $iq_server.server() + "topicrelative/data/"
						+ paramdata.topicId
			}

			$iq_http.http(params, func);
		}

		return {
			all : function() {
				return list;
			},
			getAllList : getAllList,
			getTopicRelations : getTopicRelations
			,
		}
	}

	var labelList = function($iq_http, $iq_server) {
		var list = []; // 列表数据

		var getAllList = function(callback) {// 从远程获取列表数据
			var func = {
				success : function(re) {
					list = re.data.data;
					if (callback) {
						callback(list);// 直接返回list 还是返回list.copy
					}
				}
			}
			var params = {
				method : "GET",
				url : $iq_server.server() + "label/datas"
			}

			$iq_http.http(params, func);
		}

		return {
			all : function() {
				return list;
			},
			getAllList : getAllList
			,
		}
	}

	var portalList = function($iq_http, $iq_server) {
		var list = [];
		var getNewsList = function(callback, newsParam) {
			var func = {
				success : function(re) {
					list = re.data.data;
					if (callback) {
						callback(list);
					}
				}
			}
			var params = {
				method : "GET",
				url : $iq_server.server() + "news/data/index"
			}
			$iq_http.http(params, func);
		}

		return {
			all : function() {
				return list;
			},
			getNewsList : getNewsList
			,
		}

	}

	var changeOrgService = function($iq_http, $iq_server) {
		var getOrgs = function(callback, filter) {
			var params = {
				method : "GET",
				url : $iq_server.server() + "login/user/orgs-except-logined/"
						+ filter
			}

			$iq_http.http(params).then(function(r) {
						callback(r.data);
					});
		}

		var switchOrg = function(callback, _id) {
			var params = {
				method : "GET",
				url : $iq_server.server() + "login/user/switch-to/" + _id
						+ "/org"
			}

			$iq_http.http(params).then(function(r) {
						callback(r.data);
					});
		}

		return {
			switchOrg : switchOrg,
			getOrgs : getOrgs
		}

	}

	var inviteService = function($iq_http, $iq_server) {
		var weiShare = function(data) {
			var params = {
					method : "POST",
					url : $iq_server.server() + "weChat/signature",
					data : data,
					dataType : "json"
				}
				return $iq_http.http(params);
		}
		var invite = function(data) {
			var params = {
				method : "POST",
				url : $iq_server.server() + "person/invite",
				data : data,
				dataType : "json"
			}
			return $iq_http.http(params);
		}
        
		var inviteQrcode = function(){
			var params = {
					method : "POST",
					url : $iq_server.server() + "person/inviteQrcode",
					data : data,
					dataType : "json"
				}
			return $iq_http.http(params);
		}
		return {
			invite : invite,
			inviteQrcode : inviteQrcode,
			weiShare : weiShare
		}

	}
	
	var appblog = angular.module('home').service("$moduleType",
			["$iq_http", "$iq_server", "$q", moduleType]);
	appblog.service("$microblogList", microblogList);
	appblog.service("$topicList", topicList);
	appblog.service("$labelList", labelList);
	appblog.service("$portalList", portalList);
	appblog.service("$changeOrgService", changeOrgService);
	appblog.service("$inviteService", inviteService);
	

})();